import { createSlice } from "@reduxjs/toolkit";
import { sendPromoEmails, sendTestEmail } from "./asyncThunks";

const initialState = {
  loading: false,
  testEmailLoading: false,
  results: null,
  error: null,
  progress: null, // { current, total, sent, failed, lastEmail, status }
};

const promoEmailsSlice = createSlice({
  name: "promoEmails",
  initialState,
  reducers: {
    clearResults: (state) => {
      state.results = null;
      state.error = null;
      state.progress = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    updateProgress: (state, action) => {
      state.progress = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Send promo emails
      .addCase(sendPromoEmails.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.progress = null;
        state.results = null;
      })
      .addCase(sendPromoEmails.fulfilled, (state, action) => {
        state.loading = false;
        state.results = action.payload;
      })
      .addCase(sendPromoEmails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Greška pri slanju email-ova";
        state.progress = null;
      })

      // Send test email
      .addCase(sendTestEmail.pending, (state) => {
        state.testEmailLoading = true;
        state.error = null;
      })
      .addCase(sendTestEmail.fulfilled, (state) => {
        state.testEmailLoading = false;
      })
      .addCase(sendTestEmail.rejected, (state, action) => {
        state.testEmailLoading = false;
        state.error = action.payload || "Greška pri slanju test email-a";
      });
  },
});

export const { clearResults, clearError, updateProgress } =
  promoEmailsSlice.actions;

// Selectors
export const selectPromoEmails = (state) => state.promoEmails;
export const selectPromoEmailsLoading = (state) => state.promoEmails.loading;
export const selectTestEmailLoading = (state) =>
  state.promoEmails.testEmailLoading;
export const selectPromoEmailResults = (state) => state.promoEmails.results;
export const selectPromoEmailError = (state) => state.promoEmails.error;
export const selectPromoEmailProgress = (state) => state.promoEmails.progress;

export default promoEmailsSlice.reducer;
